<template>
  <v-card :disabled="loading" flat>
    <v-card-title class="display-1 justify-center mb-8 mt-n3">
      Add storage
    </v-card-title>
    <v-card-text class="pa-0">
      <v-select
        v-model="formValues.s3_id"
        v-validate="'required'"
        :item-disabled="disableItem"
        :items="providerList"
        :menu-props="{ offsetY: true }"
        append-icon="mdi-chevron-down"
        attach
        class="mb-4"
        filled
        item-text="name"
        item-value="id"
        placeholder="Select Providers"
        v-bind="veeValidate('Providers', 'Providers')"
        @focusin.prevent="getProviderList"
      >
        <template #item="{ item }">
          <div class="d-flex align-center fill-width">
            <v-card
              :disabled="item.status !== 1"
              class="transparent d-flex justify-center align-center my-2 mr-4"
              flat
              style="width: 32px"
              tile
            >
              <img
                v-if="item.icon"
                :src="item.icon ? getStorageImg(item.icon) : null"
                height="32"
              />
            </v-card>
            {{ item.name }}
            <v-spacer />
            <v-chip
              v-if="item.status === 2"
              class="radius-10 bold-text px-3"
              style="height: 26px; padding-bottom: 2px"
            >
              In beta
            </v-chip>
            <v-chip
              v-if="item.status === 3"
              class="radius-10 bold-text px-3"
              style="height: 26px; padding-bottom: 2px"
            >
              Soon
            </v-chip>
            <v-chip
              v-if="item.status === 4"
              class="radius-10 bold-text px-3"
              style="height: 26px; padding-bottom: 2px"
            >
              Future
            </v-chip>
          </div>
        </template>
        <template #no-data>
          <div class="pa-4">
            <div
              v-if="storageLoading"
              class="d-flex align-center justify-center"
            >
              <ContentLoader size="25" />
            </div>
            <div v-else>No data available</div>
          </div>
        </template>
      </v-select>
      <v-text-field
        v-model="formValues.key"
        v-validate="'required'"
        :disabled="!formValues.s3_id"
        class="mb-4"
        filled
        placeholder="Enter Key"
        v-bind="veeValidate('Key', 'Key')"
      />
      <v-text-field
        v-model="formValues.secret"
        v-validate="'required'"
        :disabled="!formValues.s3_id"
        class="mb-4"
        filled
        placeholder="Enter Secret"
        v-bind="veeValidate('Secret', 'Secret')"
      />
    </v-card-text>
    <div class="text-center">
      <v-btn
        :disabled="
          loading ||
          errors.any() ||
          !formValues.s3_id ||
          !formValues.key ||
          !formValues.secret ||
          !(getTeamPlanUsage && getTeamPlanUsage.connect_storage)
        "
        :loading="loading"
        :outlined="$vuetify.theme.dark"
        class="py-7 px-10 text-transform-none"
        color="primary"
        x-large
        @click="createStorage"
      >
        <span class="font14"> Add </span>
      </v-btn>
    </div>
  </v-card>
</template>

<script>
import {
  CREATE_STORAGE,
  GET_PROVIDERS,
  UPDATE_STORAGE,
} from "@/store/team/storage.module";
import { mapGetters, mapMutations } from "vuex";
import veeValidate from "@/mixins/veeValidate";

export default {
  mixins: [veeValidate],
  props: {
    actionsData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      formValues: {},
      loading: false,
      storageLoading: false,
    };
  },
  computed: {
    ...mapGetters({
      providerList: "getProvidersList",
      getTeamPlanUsage: "getTeamPlanUsage",
    }),
  },
  created() {
    this.formValues = this.actionsData;
    // if (!(this.providerList && this.providerList.length)) {
    //   this.getProviderList();
    // }
  },
  methods: {
    ...mapMutations({
      appendExternalStorage: "appendExternalStorage",
    }),
    disableItem(item) {
      if (item.status !== 1) {
        return true;
      }
      return false;
    },
    async getProviderList() {
      if (!(this.providerList && this.providerList.length)) {
        this.storageLoading = true;
        await this.$store.dispatch(GET_PROVIDERS);
        this.storageLoading = false;
      }
    },
    async createStorage() {
      if (await this.validateAllFields()) {
        if (this.loading) return;
        this.loading = true;
        if (this.actionsData && this.actionsData.id) {
          this.$store
            .dispatch(UPDATE_STORAGE, this.formValues)
            .then((response) => {
              this.loading = false;
              this.notifyUserMessage({ message: response.message });
              this.$emit("refresh");
            })
            .catch((err) => {
              this.loading = false;
              this.notifyErrorMessage(err.message);
            });
        } else {
          this.$store
            .dispatch(CREATE_STORAGE, this.formValues)
            .then((response) => {
              const providerInfo = this.providerList.find(
                (provider) => provider.id === this.formValues.s3_id
              );
              const dataToAppend = {
                id: response.id,
                bucket: response.bucket || "-",
                name: providerInfo.name,
                icon: providerInfo.icon,
                endpoint: response.endpoint,
                region: providerInfo.region,
                key: this.formValues.key,
                secret: "**********",
                meta: {
                  storage: 0,
                  total_apps: 0,
                  total_releases: 0,
                },
              };
              this.appendExternalStorage(dataToAppend);
              this.notifyUserMessage({ message: response.message });
              this.$emit("refresh", response);
              this.loading = false;
            })
            .catch((err) => {
              this.loading = false;
              this.notifyErrorMessage(err.message);
            });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>